import axiosInstance from './api'
import TokenService from './token.service'
import { createSessionRecovery } from './sessionRecovery'
import { createApiConnection } from './apiConnection'

let recovery
let connection
export const reauthenticate = credentials => recovery.reauthenticate(credentials)
export const retryApiConnection = () => connection.retry()

export default (store, router) => {
  recovery = createSessionRecovery({
    api: axiosInstance, tokens: TokenService, store, router,
    channel: new BroadcastChannel('auth-messages'),
  })
  connection = createApiConnection({ api: axiosInstance, store, router })
  return { dispose() { connection.dispose(); recovery.dispose() } }
}
